// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Message list + composer of the project chat. Scoped under .project-chat-window. */

.project-chat-window {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: var(--ds-space-3);
}

.project-chat-window .project-chat-window__messages {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: var(--ds-space-2);
}

.project-chat-window .project-chat-window__messages .ant-bubble {
  margin-bottom: var(--ds-space-2);
}

.project-chat-window .project-chat-window__messages .ant-bubble-content {
  overflow-wrap: anywhere;
}

.project-chat-window .project-chat-window__preview {
  display: flex;
  justify-content: center;
  max-width: 100%;
  overflow: hidden;
}

.project-chat-window .messageFile {
  max-width: min(310px, 100%);
  max-height: 341px;
  padding: 10px;
  text-align: center;
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md);
}

.project-chat-window .messageFileLink {
  max-width: 100%;
  margin-bottom: 10px;
  padding: 10px;
  color: var(--ds-brand-strong);
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md);
  overflow-wrap: anywhere;
}

.project-chats .project-chat-sender {
  flex-shrink: 0;
  margin: 0 var(--ds-space-3) var(--ds-space-3);
}

.project-chats .project-chat-sender textarea {
  text-align: start;
}

@media (min-width: 768px) {
  .project-chat-window {
    padding: var(--ds-space-5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/commons/Projects/ProjectChats/ChatWindow/ChatWindow.css"],"names":[],"mappings":"AAAA,oFAAoF;;AAEpF;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Message list + composer of the project chat. Scoped under .project-chat-window. */\n\n.project-chat-window {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  padding: var(--ds-space-3);\n}\n\n.project-chat-window .project-chat-window__messages {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: var(--ds-space-2);\n}\n\n.project-chat-window .project-chat-window__messages .ant-bubble {\n  margin-bottom: var(--ds-space-2);\n}\n\n.project-chat-window .project-chat-window__messages .ant-bubble-content {\n  overflow-wrap: anywhere;\n}\n\n.project-chat-window .project-chat-window__preview {\n  display: flex;\n  justify-content: center;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.project-chat-window .messageFile {\n  max-width: min(310px, 100%);\n  max-height: 341px;\n  padding: 10px;\n  text-align: center;\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md);\n}\n\n.project-chat-window .messageFileLink {\n  max-width: 100%;\n  margin-bottom: 10px;\n  padding: 10px;\n  color: var(--ds-brand-strong);\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md);\n  overflow-wrap: anywhere;\n}\n\n.project-chats .project-chat-sender {\n  flex-shrink: 0;\n  margin: 0 var(--ds-space-3) var(--ds-space-3);\n}\n\n.project-chats .project-chat-sender textarea {\n  text-align: start;\n}\n\n@media (min-width: 768px) {\n  .project-chat-window {\n    padding: var(--ds-space-5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
